module.exports = __webpack_public_path__ + "img/2.625fe369.png";